<template>
  <v-container>
    <h1 class="text-capitalize heading">{{ $t('common.tos')}}</h1>
    <v-tabs :vertical="breakpoint">
      <v-tab>{{ $t('common.brands')}}</v-tab>
      <v-tab>{{ $t('common.influencers')}}</v-tab>
      <v-tab-item>
        <v-container>
          <h1 class="heading">{{ body[1].data.title[0].text }}</h1>
          <p>
            <prismic-rich-text :field="body[1].data.content" />
          </p>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <h1 class="heading">{{ body[0].data.title[0].text }}</h1>
          <p class="mb-0">
            <prismic-rich-text :field="body[0].data.content" />
          </p>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <v-skeleton-loader :loading="loading" :transition="transition" type="article">
      <div>
        <prismic-rich-text :field="body" />
      </div>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
export default {
  name: 'Terms',
  data: () => ({
    loading: true,
    transition: 'scale-transition',
    body: null,
  }),
  created() {
    this.getContent();
  },
  computed: {
    breakpoint() {
      // eslint-disable-next-line default-case
      if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
        return false;
      }
      return true;
    },
  },
  methods: {
    getContent() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at('document.type', 'terms'), {
          lang: this.$i18n.locale,
        })
        .then((document) => {
          this.body = document.results;
          this.loading = false;
        });
    },
    signUp() {},
  },
};
</script>

<style scoped>
</style>
